import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { Error500 } from 'reactShared/page/Error500'

import { AppLayout } from '../components/AppLayout'
import { SignUp } from '../pages/SignUp'
import { Success } from '../subpages/Success'
import PrivateRoute from './components/PrivateRoute.js'

function Routes () {
  return (
    <BrowserRouter>
      <Switch>
        <AppLayout>
          <Route exact path="/cadastre-se" component={SignUp} />
          <Route path="/erro-interno" component={Error500} />
          <PrivateRoute path="/sucesso" component={Success} />
        </AppLayout>
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
